const resourceNames = {
  'FirstName': 'Individuals.Name',
  'BirthDate': 'Individuals.BirthDate',
  'GovernmentServiceYears': 'Individuals.Years',
  'GovernmentServiceDirectorate': 'Individuals.Directorate',
  'Name': 'Common.ArabicName',
  'LatinName': 'Common.LatinName',
  'Code': 'Institutions.Code',
  'ApprovalNumber': 'Common.ApprovalNumber',
  'OwnershipType': 'Institutions.OwnershipType',
  'ChangeDate': 'Common.ChangeDate',
  'PropertyType': 'Institutions.PropertyType',
  'SequenceNumber': 'Institutions.SequenceNumber',
  'BankType': 'Common.Type',
  'BankNationality': 'Institutions.Nationality',
  'Blacklist': 'Blacklists.Type',
  'PersonType': 'Institutions.PersonTypes',
  'Person': 'Institutions.RelatedIndividualOrInstitution',
  'Reason': 'Common.Reason',
  'Description': 'Common.Description',
  'ValidFrom': 'Common.ValidFrom',
  'ValidTo': 'Common.ValidTo',
  'PenaltySource': 'Fines.Type',
  'FineStatus': 'Fines.Status',
  'Amount': 'Common.Amount',
  'Date': 'Common.Date'

}

export default function fieldNameTransform (fieldName) {
  if (fieldName in resourceNames) {
    return resourceNames[fieldName]
  } else {
    return fieldName
  }
}



// WEBPACK FOOTER //
// ./src/utils/fieldNameTransform.js